<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.28607 12.714C0.6792 10.1071 0.6792 5.89273 3.28607 3.28586C5.89293 0.678996 10.1073 0.678996 12.7142 3.28586C15.321 5.89273 15.321 10.1071 12.7142 12.714C10.1073 15.3208 5.89293 15.3208 3.28607 12.714ZM11.3895 8.66459C11.7572 8.66459 12.0542 8.3676 12.0542 7.99991C12.0495 7.63692 11.7478 7.33523 11.3895 7.33522L8.66479 7.33522V4.61051C8.66479 4.24281 8.36781 3.94583 8.00011 3.94583C7.63242 3.94583 7.33543 4.24281 7.33543 4.61051L7.33543 7.33522L4.61072 7.33522C4.24302 7.33522 3.94604 7.63221 3.94604 7.9999C3.94584 8.17625 4.0158 8.34543 4.1405 8.47012C4.26519 8.59482 4.43437 8.66478 4.61072 8.66459L7.33543 8.66459L7.33543 11.3893C7.33524 11.5656 7.4052 11.7348 7.52989 11.8595C7.65459 11.9842 7.82377 12.0542 8.00011 12.054C8.36781 12.054 8.66479 11.757 8.66479 11.3893V8.66459L11.3895 8.66459Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
